import { transparentTag as css } from '@tencent/exeditor3-core';
function nest(replaceValue, str) {
    return str.replace(/&/g, replaceValue);
}
const toolbarStyle = nest('.exeditor-toolbar', css `
    &[data-theme='basic'] {
      --exeditor-table-panel-cell-active-color: #b2d1ff;
      --exeditor-toolbar-option-hover-color: #f6f6f6;
      --exeditor-toolbar-button-font-size: 14px;
      --exeditor-toolbar-option-height: 36px;
      --exeditor-toolbar-option-padding: 0 16px;
      --exeditor-toolbar-button-in-dropdpwn-hover-color: #f0f0f0;
      --exeditor-toolbar-option-selected-font-weight: bold;
      --exeditor-toolbar-tolltip-background-color: #404040;
      --exeditor-toolbar-color: #555;
      --exeditor-toolbar-button-width: 30px;
      --exeditor-toolbar-button-height: 30px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 15px;
      color: var(--exeditor-toolbar-color, #555);
      background: #fcfcfc;
    }
    &[data-theme='basic'][data-in='popover'] {
      box-sizing: border-box;
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      max-width: 100%;
      padding: 5px;
      border-radius: 4px;
      box-shadow: 0 0 10px 5px rgb(0 0 0 / 6%);
    }
    &--multiline[data-theme='basic'] {
      flex-direction: column;
      align-items: flex-start;
    }
    &--multiline[data-theme='basic'] > &__row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    &[data-theme='basic'] [data-toolbar-item-of] {
      flex-basis: 0;
      margin: 0 5px;
      white-space: nowrap;
    }
  `);
// 还有些 table 编辑态的样式残留，plugin-tables 优化时拆走
const editAreaStyle = nest('.ExEditor-basic', css `
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    & {
      box-sizing: border-box;
      min-height: 100px;
      background: white;
      padding: 20px;
      outline: none;
      white-space: pre-wrap;
      --exeditor-hr-color: #e7e7e7;
      --exeditor-link-color: #0052ff;
      --exeditor-selected-outline: 2px solid #68cef8;
      --exeditor-selected-background: rgba(24, 144, 255, 0.3);
      --exeditor-selected-cell-background: rgba(24, 144, 255, 0.15);
      --exeditor-formula-vertical-align: middle;
    }
    & a:any-link {
      color: var(--exeditor-link-color);
      text-decoration: underline;
    }
    & h1 {
      font-size: 2em;
    }
    & p {
      line-height: 26px;
      min-height: 1em;
    }
    & blockquote {
      background: #00000008;
      border-left: 6px solid #ccc;
      margin: 1.5em 10px;
      padding: 0.5em 10px;
    }
    & pre {
      padding: 6px;
      background: #efefef;
      overflow: auto;
    }
    & p,
    & pre {
      margin-top: 15px;
      margin-bottom: 15px;
    }
    & hr {
      border-width: 2px 0 0 0;
      border-style: solid;
      border-color: var(--exeditor-hr-color);
      margin-top: 1.5em;
      margin-bottom: 1.5em;
    }
    & img[data-formula] {
      vertical-align: var(--exeditor-formula-vertical-align);
    }
    & video {
      display: block;
      margin: 1em auto;
    }
    & video[data-inline] {
      display: inline-block;
      margin: 0;
    }
    & video:not([data-inline]) {
      width: auto;
      height: auto;
      max-width: 100%;
    }
    & audio {
      display: block;
      margin: 1em auto;
    }
    & audio[data-inline] {
      display: inline-block;
      margin: 0 2px;
    }
    &.ProseMirror-focused .excore-selected-node:not(.no-outline) {
      outline: var(--exeditor-selected-outline);
    }
    &.ProseMirror-focused .excore-in-selection {
      background: var(--exeditor-selected-background);
      box-shadow: 0 0 0 2px var(--exeditor-selected-background);
    }
    & .tableWrapper {
      margin: 20px 0;
      padding: 0;
      overflow-x: auto;
    }
    & table {
      min-width: fit-content;
      border-collapse: collapse;
      margin: 0;
      overflow: hidden;
    }
    & table th,
    & table td {
      box-sizing: border-box;
      position: relative;
      min-width: 70px;
      padding: 0px 5px;
      border: 2px solid #dcdcdc;
      vertical-align: top;
      background-clip: padding-box;
    }
    & table th {
      font-weight: bold;
      background-color: #f3f3f3;
    }
    & table td {
      background-color: white;
    }
    & table th > p,
    & table td > p {
      min-height: 1em;
    }
    & table .selectedCell::after {
      z-index: 2;
      position: absolute;
      content: '';
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: var(--exeditor-selected-cell-background);
      pointer-events: none;
    }
    &.resize-cursor {
      cursor: col-resize;
    }
    & table .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }
  `);
const markerStyle = nest('.ExEditor-basic', css `
    & ol {
      --ol-start: 1;
      --ol-list-style-type: decimal;
      list-style-type: none;
      counter-reset: olCounter calc(var(--ol-start, 1) - 1);
      position: relative;
    }
    & ol > li > :first-child::before {
      content: counter(olCounter, var(--ol-list-style-type)) '. ';
      counter-increment: olCounter;
      font-variant-numeric: tabular-nums;
      position: absolute;
      transform: translate(-100%, 0);
    }

    & ul {
      --ul-list-style-type: circle;
      list-style-type: none;
      position: relative;
    }
    & ul.nonUnicode-list-style-type > li > :first-child::before {
      content: var(--ul-list-style-type) ' ';
      font-variant-numeric: tabular-nums;
      position: absolute;
      transform: translate(-100%, 0.05em) scale(0.5);
    }
    & ul.unicode-list-style-type > li > :first-child::before {
      content: var(--ul-list-style-type) ' ';
      font-variant-numeric: tabular-nums;
      position: absolute;
      transform: translate(-100%, 0) scale(0.8);
    }
  `);
const todoStyle = nest('.ExEditor-basic', css `
    & ul[data-type='todo'] {
      padding-left: calc(2em + 10px);
    }
    & ul[data-type='todo'] > li > :first-child::before {
      content: '';
    }
    & ul[data-type='todo'] > li > input[type='checkbox'] {
      position: absolute;
      left: 1em;
      margin-top: 6px;
      margin-right: 10px;
    }
  `);
export class BasicTheme {
    constructor() {
        this.namespace = 'basic';
        // temp var for easy debug toggle
        const useNativeListMarker = false;
        this.styles = `${toolbarStyle}${editAreaStyle}${useNativeListMarker ? '' : markerStyle}${todoStyle}`;
    }
}
//# sourceMappingURL=index.js.map